// extracted by mini-css-extract-plugin
module.exports = {"location-section":"location-section","title":"title","icon":"icon","content-list":"content-list"};